import { render, staticRenderFns } from "./DisapproveChecklistModal.vue?vue&type=template&id=72872748&scoped=true&"
import script from "./DisapproveChecklistModal.vue?vue&type=script&lang=js&"
export * from "./DisapproveChecklistModal.vue?vue&type=script&lang=js&"
import style0 from "./DisapproveChecklistModal.vue?vue&type=style&index=0&id=72872748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72872748",
  null
  
)

export default component.exports